import { render, staticRenderFns } from "./preferentialrules.vue?vue&type=template&id=2f925e72&"
import script from "./preferentialrules.vue?vue&type=script&lang=js&"
export * from "./preferentialrules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports